import { LogicContext } from '../types';
import { getCategories } from '../utils';

import Window from '../../../ports-frontend/Window';
import config from '../../../config';

export const getCategoriesLayoutContent = async (context: LogicContext) => {
  const {
    callbackMode,
    currentJackpots,
    currentTables,
    currentPersonalizedBanners,
    controllersData,
    user,
  } = context;
  const locale = config.locale;
  const currency = user?.currency || config.default_currency;
  const windowInnerWidth = await Window.getInnerWidth();
  if (!controllersData?.categories) {
    return {
      updates: [],
    };
  }

  const updates = controllersData.categories!.components.map(componentEntry => {
    const [id, entry] = componentEntry;
    const category = entry.properties;
    const readyCategory = getCategories({
      categories: [category],
      currentJackpots,
      currentTables,
      currentPersonalizedBanners,
      windowInnerWidth,
      currency,
      locale,
    })[0];

    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          category: readyCategory,
          currency,
          locale,
          callbackMode,
          visible: true,
          displayInMainSection: !!context.currentLayout?.components
            .SideNavigation,
        },
      },
    };
  });

  return {
    updates,
  };
};
